import React, { useEffect } from 'react'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import Teenager from './teenager'
import YoungWoman from './young-woman'
import Heartrob from './heartrob'
import Mother from './mother'
import Example from './example'
import Blessing from './blessing'

const Timeline: React.FC = () => {
	useEffect(() => {
		gsap.registerPlugin(ScrollTrigger, CSSRulePlugin)

		let sections = gsap.utils.toArray('.timeline-section')

		let ctx = gsap.context(() => {
			let container = document.querySelector('.timeline--container') as HTMLDivElement

			let scrollTween = gsap.to(sections, {
				xPercent: -100 * (sections.length - 1),
				ease: 'none', // <-- IMPORTANT!
				scrollTrigger: {
					trigger: '.timeline--container',
					pin: true,
					scrub: 0.5,
					start: 'top top',
					invalidateOnRefresh: true,
					// snap: directionalSnap(1 / (sections.length - 1)),
					snap: 1 / (sections.length - 1),
					end: () => `+=${container.offsetWidth}`,
					fastScrollEnd: 3000, // (custom 3000px/s velocity)
					preventOverlaps: true,
				},
			})
		})

		return () => ctx.revert()
	}, [])

	return (
		<div className='timeline--container'>
			<Teenager />
			<YoungWoman />
			<Heartrob />
			<Mother />
			<Example />
			<Blessing />
		</div>
	)
}

export default Timeline
